export type AiBudgetPlan = "FREE" | "PREMIUM" | "PRO";
export type AiLimitType =
  | "ai_budget"
  | "ai_rolling_window"
  | "free_pronunciation"
  | "free_monthly_budget"
  | "free_dictation"
  | "ai_generation";

export interface AiBudgetStatus {
  plan: AiBudgetPlan;
  pronunciationLanguage?: string | null;
  remainingPronunciationSeconds: number;
  maxRecordingSeconds: number;
  freeChecksRemaining: number | null;
  freeChecksLimit: number | null;
  blockedReason: AiLimitType | null;
  availableAt: string | null;
  aiGenerationAllowed: boolean;
  dictation: {
    remaining: number | null;
    limit: number | null;
    quotaPeriod: "LIFETIME" | "UNLIMITED";
  };
}

export interface AiAnalyticsEvent {
  event: "limit_reached" | "paywall_shown";
  location: string;
  limitType?: AiLimitType;
}

export function isAiLimitType(input: unknown): input is AiLimitType {
  return (
    typeof input === "string" &&
    [
      "ai_budget",
      "ai_rolling_window",
      "free_pronunciation",
      "free_monthly_budget",
      "free_dictation",
      "ai_generation",
    ].includes(input)
  );
}
